// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1O9W1","avatar":"style_avatar__bIyg9","menuIcon":"style_menuIcon__27Dzb"};